<template>
    <div class="laycont">
        <div class="laycont-box" v-loading="upload_process">
            <el-upload :action="uploadUrl" list-type="picture-card" :before-upload="beforeUpload" :disabled="disabled"
                :show-file-list="false" class="avatar-uploader" :http-request="handleUploadFun"
                :on-preview="handlePreview" :accept="acceptAttr" v-if="isSingle">
                <div v-if="imageUrl" class="img-preview-wrap">
                    <img v-if="isImageUrl(imageUrl)" :src="imageUrl" class="single-preview-img" />
                    <div v-else class="file-card">
                        <div class="file-card-view" @click.stop="openFile(imageUrl)">
                            <i class="el-icon-document"></i>
                            <span class="file-card-text">{{ getFileTypeText(imageUrl) }}</span>
                        </div>
                        <span class="file-card-reupload">点击更换</span>
                    </div>
                </div>
                <div class="icon-box" v-else>
                    <i class="el-icon-upload2"></i>
                </div>
            </el-upload>
            <template v-else>
                <!-- acceptFile 模式下自渲染文件/图片列表（el-upload 内置缩略图无法展示非图片） -->
                <template v-if="acceptFile">
                    <div class="multi-file-item" v-for="(item, idx) in fileList" :key="idx">
                        <div class="multi-file-item-del" @click="handleDelFileItem(idx)">
                            <i class="el-icon-delete"></i>
                        </div>
                        <img v-if="isImageUrl(item.url)" :src="item.url" class="multi-file-item-img"
                            @click="handlePreview(item)" />
                        <div v-else class="file-card" @click="openFile(item.url)">
                            <i class="el-icon-document"></i>
                            <span class="file-card-text">{{ getFileTypeText(item.url) }}</span>
                        </div>
                    </div>
                </template>
                <el-upload :action="uploadUrl" list-type="picture-card" :before-remove="handleRemove"
                    :before-upload="beforeUpload" :disabled="disabled" :file-list="fileList"
                    :show-file-list="!acceptFile" :http-request="handleUploadFun" :on-preview="handlePreview"
                    :accept="acceptAttr" class="img-uploader">
                    <div class="icon-box">
                        <i class="el-icon-plus"></i>
                    </div>
                </el-upload>
                <el-dialog v-model="dialogVisible" append-to-body>
                    <img :src="imageUrl" alt="" width="100%">
                </el-dialog>
            </template>
        </div>

    </div>
</template>

<script>
import { getFileExt, isImageUrl, getFileTypeText } from '@/utils';
export default {
    name: 'upload-img',
    props: {
        value: {
            type: [String, Array],
            default() { }
        },
        isSingle: { // 是否是单张图片
            type: Boolean,
            default: true
        },
        uploadUrl: {
            type: String,
            default: ``
        },
        //上传文件大小限制
        fileSize: {
            type: Number,
            default: parseInt(1024 * 1024 * 20) / 1024 / 1024, //单位：M
        },
        //diy上传方法回调
        callFun: {
            type: Function,
            default: () => { }
        },
        //刷新方法回调
        refushVal: {
            type: Function,
            default: () => { }
        },
        //是否禁用上传，禁止点击
        disabled: {
            type: Boolean,
            default: false
        },
        filed: {
            type: String,
            default: ''
        },
        //是否放开文件上传（pdf/doc/docx/xls/xlsx），默认仅图片
        acceptFile: {
            type: Boolean,
            default: false
        }
    },
    emit: ['input'],
    data() {
        return {
            imageUrl: '',
            fileList: [],
            dialogVisible: false, //图片预览展开、隐藏控制
            upload_process: false,
        };
    },

    computed: {
        //el-upload accept 属性
        acceptAttr() {
            const imgAccept = 'image/jpeg,image/png,image/gif,.jpg,.jpeg,.png,.gif';
            return this.acceptFile
                ? imgAccept + ',.pdf,.doc,.docx,.xls,.xlsx'
                : imgAccept;
        }
    },

    watch: {
        fileList: {
            handler(newArr, oldArr) {
                //更新预览图片的信息
                let newLen = newArr.length
                newLen = newLen > 0 ? --newLen : newLen;
                let lastImg = newArr[newLen] || ''
                this.imageUrl = !!!lastImg ? '' : lastImg.url || '';
                //调用刷新父级数据
                let arr = []
                newArr.forEach(item => {
                    arr.push({
                        name: item.name,
                        url: item.url
                    })
                })
                this.refushVal(arr)
            },
            immediate: true,
            deep: true
        },
        // value(val) {
        //     const {
        //         isSingle
        //     } = this;
        //     if (isSingle) {
        //         this.imageUrl = val;
        //     } else {
        //         this.imageUrl = val || [];
        //         this.fileList = val || []
        //     }
        // }
    },
    beforeDestory() {
        this.initFileList([])
    },

    methods: {
        isImageUrl(url) {
            return isImageUrl(url);
        },
        getFileTypeText(url) {
            return getFileTypeText(url);
        },
        //新窗口打开文件
        openFile(url) {
            if (url) window.open(url, '_blank');
        },
        beforeUpload(file) {
            return this.checkFile(file)
        },
        checkFile(file) {
            const {
                fileSize
            } = this;
            // 以扩展名为主判断，扩展名缺失时回退到 MIME（MIME 可能为空或不标准）
            const ext = getFileExt(file.name || '');
            const imgExts = ['jpg', 'jpeg', 'png', 'gif'];
            const imgMimes = ['image/jpeg', 'image/png', 'image/gif'];
            const docExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx'];
            const docMimes = ['application/pdf', 'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            const allowExts = this.acceptFile ? imgExts.concat(docExts) : imgExts;
            const allowMimes = this.acceptFile ? imgMimes.concat(docMimes) : imgMimes;
            const isAllow = ext ? allowExts.indexOf(ext) !== -1 : allowMimes.indexOf(file.type) !== -1;
            const isLt2M = file.size / 1024 / 1024 < fileSize;

            if (!isAllow) {
                this.$message.error(this.acceptFile
                    ? '上传文件只能是 JPG/PNG/GIF/PDF/Word/Excel 格式!'
                    : '上传图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error(`上传文件大小不能超过 ${fileSize}MB!`);
            }
            return isAllow && isLt2M;

        },
        //删除文件，回调父级函数更新处理
        handleRemove(file, fileList) {
            this.$emit('input', fileList);
        },
        //acceptFile 多图模式下删除单个文件
        handleDelFileItem(index) {
            this.fileList.splice(index, 1);
            this.$emit('input', this.fileList);
        },
        //自动上传模式，自定义上传方法
        handleUploadFun(params) {
            const file = params.file;
            //检查图片 &&（并回调上传fun）
            this.checkFile(file) && this.sendUpload(file)
        },
        //发送上传文件
        sendUpload(files) {
            // var form = new FormData();
            // files.forEach(item => {
            //     // form.append("file", item, item.name);
            //     form.append("file", item);
            // })
            this.upload_process = true;
            this.callFun(files,this.filed)

        },


        handlePreview(file) {
            //非图片文件直接新窗口打开
            if (!this.isImageUrl(file.url)) {
                this.openFile(file.url);
                return;
            }
            this.imageUrl = file.url;
            this.dialogVisible = true;
        },

        //上传成功，刷新文件列表（父组件的上传方法成功后的回调，刷新本组件的文件列表）
        //data: array 上传成功之后返回的文件列表
        //formData： formdata  上传文件提交的form表单对象，获取上传文件时候的文件名字
        uploadSuccess(data, formData) {
            this.upload_process = false;
            if (data.length == 0) {
                this.fileList = [...this.fileList]
                if (this.isSingle) {
                    this.imageUrl = '';
                }
            } else {
                if (this.isSingle) {
                    // 单张图片模式
                    this.imageUrl = data[0].url;
                } else {
                    // 多张图片模式
                    this.refushFileList(data)
                }
            }
        },

        //刷新文件列表方法
        refushFileList(files) {
            files.forEach((item) => {
                // let getName = item.imageUrl.match(/\/(\w+\.(?:png|jpg|gif|bmp))$/i)[1];
                // this.fileList.push({
                //     name: getName,
                //     url: item.imageUrl
                // })


                // let getName = item.url.match(/\/(\w+\.(?:png|jpg|gif|bmp))$/i)[1];
                this.fileList.push({
                    name: item.name || '',
                    url: item.url
                })
            })
        },
        //重置，初始化，清空文件列表
        initFileList(files) {
            this.fileList = files || []
        },

    }
}
</script>

<style lang="scss" scoped>
.laycont,
.laycont * {
    box-sizing: border-box !important;
}

.laycont {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .laycont-box {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

}

.img-uploader {
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .el-upload:hover {
        border-color: #409EFF;
    }
}

.icon-box {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-upload--picture-card) {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    /* 不覆盖 height，让 Element UI 默认的 148px 生效 */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 100%;
        width: auto;
        max-height: 100%;
        height: auto;
        display: block;
    }
}

/* 单图模式：wrapper 填满上传框并做 flex 居中 */
.img-preview-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.single-preview-img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}

/* 非图片文件卡片 */
.file-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #475569;

    .file-card-view {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            color: #0369A1;
        }

        i {
            font-size: 36px;
            color: #0369A1;
        }

        .file-card-text {
            font-size: 12px;
            margin-top: 6px;
        }
    }

    .file-card-reupload {
        font-size: 12px;
        color: #94A3B8;
        margin-top: 8px;
        cursor: pointer;
    }
}

/* acceptFile 多图模式自渲染列表项 */
.multi-file-item {
    width: 100px;
    height: 100px;
    margin: 0 8px 8px 0;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    vertical-align: top;
    background: #fbfdff;

    .multi-file-item-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        cursor: pointer;
    }

    .multi-file-item-del {
        width: 22px;
        height: 22px;
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 10;
        background: rgba(244, 63, 94, 0.85);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        cursor: pointer;

        &:hover {
            background: #F43F5E;
        }

        i {
            color: #fff;
            font-size: 12px;
        }
    }
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 100px;
    height: 100px;
}

:deep(.el-upload-list--picture-card .el-upload-list__item)-thumbnail {
    height: auto;
}

:deep(.avatar-uploader) {
    // border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

:deep(.avatar-uploader .el-upload) {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
    /* 不覆盖 height，让 Element UI 默认的 148px 生效 */
}

:deep(.avatar-uploader .el-upload:hover) {
    border-color: #409EFF;
}



:deep(.avatar) {
    width: 100%;
    height: 100%;
    display: block;
}
</style>